import { HISTORY_BASE_URL } from '../utils/ApiUrls';

class HistoryService {
  // Fetch user history logs
  async getUserHistory(accessToken, filters = {}, pagination_data = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (filters.user_id) {
        queryParams.append('user_id', filters.user_id);
      }
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }

      const queryString = queryParams.toString();
      const url = `${HISTORY_BASE_URL}/user-history/${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });


      const data = await response.json();
      
      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching user history',
          errorData: data,
        };
      }
      
      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Fetch details for a single user history entry
  async getUserHistoryDetail(historyId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/user-history/${historyId}/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching user history detail',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Fetch risk history logs
  async getRiskHistory(accessToken, filters = {}, pagination_data = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (filters.risk_id) {
        queryParams.append('risk_id', filters.risk_id);
      }
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }

      const queryString = queryParams.toString();
      const url = `${HISTORY_BASE_URL}/risk-history/${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching risk history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Fetch details for a single risk history entry
  async getRiskHistoryDetail(historyId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/risk-history/${historyId}/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching risk history detail',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // // Fetch activity history logs
  // async getActivityHistory(accessToken, filters = {}, pagination_data = {}) {
  //   try {
  //     const queryParams = new URLSearchParams();
  //     if (filters.activity_id) {
  //       queryParams.append('activity_id', filters.activity_id);
  //     }
  //     if (pagination_data.page) {
  //       queryParams.append('page', pagination_data.page);
  //     }
  //     if (pagination_data.page_size) {
  //       queryParams.append('page_size', pagination_data.page_size);
  //     }

  //     const queryString = queryParams.toString();
  //     const url = `${HISTORY_BASE_URL}/activity-history/${queryString ? `?${queryString}` : ''}`;

  //     const response = await fetch(url, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       return {
  //         success: false,
  //         status: response.status,
  //         error: data.detail || 'Error fetching activity history',
  //         errorData: data,
  //       };
  //     }

  //     return {
  //       success: true,
  //       status: response.status,
  //       data,
  //     };
  //   } catch (error) {
  //     return {
  //       success: false,
  //       status: 0,
  //       error: error.message || 'Network error occurred',
  //       errorData: null,
  //     };
  //   }
  // }

  // // Fetch details for a single activity history entry
  // async getActivityHistoryDetail(historyId, accessToken) {
  //   try {
  //     const response = await fetch(`${HISTORY_BASE_URL}/activity-history/${historyId}/`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       return {
  //         success: false,
  //         status: response.status,
  //         error: data.detail || 'Error fetching activity history detail',
  //         errorData: data,
  //       };
  //     }

  //     return {
  //       success: true,
  //       status: response.status,
  //       data,
  //     };
  //   } catch (error) {
  //     return {
  //       success: false,
  //       status: 0,
  //       error: error.message || 'Network error occurred',
  //       errorData: null,
  //     };
  //   }
  // }


  // Fetch activity history logs (combined Activity + ActivityRisk history)
async getActivityHistory(accessToken, filters = {}, pagination_data = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (filters.activity_id) {
      queryParams.append('activity_id', filters.activity_id);
    }
    if (pagination_data.page) {
      queryParams.append('page', pagination_data.page);
    }
    if (pagination_data.page_size) {
      queryParams.append('page_size', pagination_data.page_size);
    }

    const queryString = queryParams.toString();
    const url = `${HISTORY_BASE_URL}/activity-history/${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: data.detail || 'Error fetching activity history',
        errorData: data,
      };
    }

    return {
      success: true,
      status: response.status,
      data,
    };
  } catch (error) {
    return {
      success: false,
      status: 0,
      error: error.message || 'Network error occurred',
      errorData: null,
    };
  }
}

  // Fetch details for a single history entry
  // historyType: 'activity' or 'activity_risk'
  async getActivityHistoryDetail(historyType, historyId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/activity-history/${historyType}/${historyId}/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching activity history detail',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }



  // Fetch process history logs
  async getProcessHistory(accessToken, filters = {}, pagination_data = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (filters.process_id) {
        queryParams.append('process_id', filters.process_id);
      }
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }

      const queryString = queryParams.toString();
      const url = `${HISTORY_BASE_URL}/process-history/${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching process history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Fetch details for a single process history entry
  async getProcessHistoryDetail(historyId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/process-history/${historyId}/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching process history detail',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Fetch process task history logs
  async getProcessTaskHistory(accessToken, filters = {}, pagination_data = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (filters.process_task_id) {
        queryParams.append('process_task_id', filters.process_task_id);
      }
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }

      const queryString = queryParams.toString();
      const url = `${HISTORY_BASE_URL}/process-task-history/${queryString ? `?${queryString}` : ''}`;

      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching process task history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Fetch details for a single process task history entry
  async getProcessTaskHistoryDetail(historyId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/process-task-history/${historyId}/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching process task history detail',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
}

const historyService = new HistoryService();
export default historyService;
